/* /training/demo — Faitharama Mini Lesson Demo
   Shows what every future mini training course will look like.
   Uses Mike's existing "MB Sample 2" video as the background. */
import { useEffect } from "react";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import KineticLesson from "../components/KineticLesson";
import { CheckCircle2 } from "lucide-react";

const G   = "#2E9F3A";
const O   = "#F39A1F";
const RED = "#C9202E";
const INK = "#0F172A";

const VIDEO = "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/8989hdbk_MB%20Sample%202%20%282%29.mp4";

/* The 2-3 minute script in kinetic-card format.
   Each card displays from `time` (seconds) until the next card starts. */
const SCRIPT = [
  { time: 0,   text: "FAITHARAMA.COM",                     kind: "title",   subtitle: "Mini Lesson #1 — What We're About" },
  { time: 6,   text: "One Platform.",                      kind: "tagline" },
  { time: 12,  text: "Faith. Wellness. Income.",           kind: "tagline" },
  { time: 19,  text: "Built for everyone.",                kind: "tagline", subtitle: "Believer or not. Welcome on the platform." },
  { time: 27,  text: "12 Powerful Builders.",              kind: "stat" },
  { time: 34,  text: "One Login.",                         kind: "tagline" },
  { time: 41,  text: "Funnels · Stores · Courses · Email", kind: "tagline" },
  { time: 49,  text: "AI Writer · Ask Mike · Mirror Site", kind: "tagline" },
  { time: 57,  text: "Book Covers · Appointments · Leads", kind: "tagline" },
  { time: 65,  text: "If you can post on Facebook,",       kind: "quote" },
  { time: 71,  text: "you can run a Faitharama page.",     kind: "quote" },
  { time: 79,  text: "50/50.",                             kind: "stat",    subtitle: "We split everything fifty-fifty with our affiliates." },
  { time: 89,  text: "Same rate. Trial or paid.",          kind: "tagline" },
  { time: 97,  text: "No tiers. No hoops.",           kind: "tagline" },
  { time: 105, text: "Promote. We track. You get paid.",   kind: "tagline" },
  { time: 115, text: "Clean. Family-friendly.",            kind: "tagline" },
  { time: 122, text: "Personally vetted by Mike.",         kind: "tagline" },
  { time: 130, text: "Building God's Kingdom",             kind: "title",   subtitle: "Through faith and wellness — for those who want to" },
  { time: 140, text: "7 Days Free.",                      kind: "stat" },
  { time: 148, text: "No credit card. No catch.",          kind: "tagline" },
  { time: 156, text: "Faitharama.com",                     kind: "title",   subtitle: "Start your free trial today" },
  { time: 168, text: "See you on the inside.",             kind: "quote" },
];

export default function MiniLessonDemoPage() {
  useEffect(() => {
    document.title = "Faitharama Mini Lesson — Demo";
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <SiteNav />

      <section className="py-10 md:py-14 bg-white">
        <div className="max-w-5xl mx-auto px-5 md:px-8">

          <div className="text-center mb-7">
            <div className="text-[10px] tracking-[0.32em] uppercase font-bold mb-2" style={{ color: RED }}>
              ★ Mini Training — Format Demo
            </div>
            <h1 className="font-serif-display uppercase leading-[0.98]"
                style={{ color: INK, fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}>
              This Is What Every Faitharama <br />
              <span style={{ color: G }}>Mini Course</span> Will Look Like.
            </h1>
            <p className="text-base md:text-lg mt-4 max-w-2xl mx-auto" style={{ color: INK }}>
              Mike on camera. Big headline phrases printing across the screen. 2–3 minutes per lesson. Hit play below.
            </p>
          </div>

          {/* THE PLAYER */}
          <KineticLesson
            videoUrl={VIDEO}
            title="What Faitharama Is"
            subtitle="Mini Lesson #1 · 3 minutes"
            duration={180}
            cards={SCRIPT}
          />

          {/* Feature highlights below */}
          <div className="mt-10 grid sm:grid-cols-3 gap-5" data-testid="format-highlights">
            {[
              { t: "2–3 Minutes Each", d: "Short enough for any senior. Long enough to teach one real lesson." },
              { t: "You On Camera", d: "Your voice. Your face. The thing every other AI-built site can't fake." },
              { t: "Kinetic Headlines", d: "Big phrases print on top of your video so the key idea sticks every time." },
            ].map((b) => (
              <div key={b.t} className="rounded-xl border-2 p-5 shadow-sm bg-white" style={{ borderColor: G }}>
                <CheckCircle2 className="w-7 h-7 mb-3" style={{ color: G }} />
                <h3 className="font-bold uppercase text-lg mb-2" style={{ color: INK }}>{b.t}</h3>
                <p className="text-base leading-relaxed" style={{ color: INK }}>{b.d}</p>
              </div>
            ))}
          </div>

          <p className="mt-8 text-center text-base md:text-lg italic" style={{ color: INK, opacity: 0.75 }}>
            Like this? Same format gets applied to <strong>every</strong> Faitharama mini course — Super Affiliate Training, Apologetics, Wellness, and the Build-A-Business series.
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
